import Header from "../../components/Header";
import Container from "../../components/Container";
import Footer from "../../components/Footer";
import styles from "./Watch.module.css";
import { useParams } from "react-router-dom";
import videos from "../../json/videos.json";
import PageNotFound from "../PageNotFound";
import ScrollToTopButton from "../../components/ScrollToTopButton";
import Banner from "../../components/Banner";

function Watch() {
    const params = useParams();
    const video = videos.find(video => video.id === params.id);
   if (!video) { return <PageNotFound /> }
    return (
        <>
            <ScrollToTopButton />
            <Header />
            <Banner image="Assistir"/>

            <Container>
                <section className={styles.watch}>
  
                    <iframe 
                        width="854" height="480" 
                        src={`https://www.youtube.com/embed/${video.id}`}
                        title="YouTube video player" 
                        frameborder="7" 
                        allow="accelerometer; autoplay; clipboard-write; 
                        encrypted-media; gyroscope; picture-in-picture;web-share"referrerpolicy="strict-origin-when-cross-origin"   
                        allowfullscreen></iframe>
                </section>
            </Container>
            <Footer />
        </>

    );
}

export default Watch;